/** @format */

import {WIDGETS_LIST} from 'pages/Home/DigitalCast/constants/widgets';
import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {Space} from 'pages/Home/DigitalCast/models/spaces';

const getUsedWidgets = (data: Space): ChartIds[] => {
  return data.widgetsBoardSelected.toSorted((a, b) => {
    const orderA = WIDGETS_LIST[a].order || 0;
    const orderB = WIDGETS_LIST[b].order || 0;
    return orderB - orderA;
  });
};

export default getUsedWidgets;
